export const GET_MERCHANT_AGREEMENTS = "GET_MERCHANT_AGREEMENTS"
export const GET_MERCHANT_AGREEMENTS_SUCCESS = "GET_MERCHANT_AGREEMENTS_SUCCESS"
export const GET_MERCHANT_AGREEMENTS_FAIL = "GET_MERCHANT_AGREEMENTS_FAIL"

export const MERCHANT_AGREEMENTS_API_ERROR = "MERCHANT_AGREEMENTS_API_ERROR"
